import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
// import {scrollToggleFixed} from "../../utils/scrollFixedNav";

require('../../../sitio');
const PopupManager = require('@/utils/PopupManager');
import initLocationMap from "../../../utils/initLocationMap";
import InitTabs from '@utils/initTabs';
import AccordionSlider, { Autoplay, Buttons, Breakpoints, TouchSwipe } from 'accordion-slider-js';
import 'accordion-slider-js/css';
// import 'accordion-slider-js/css/buttons';
import 'accordion-slider-js/css/layers';
import 'accordion-slider-js/css/touch-swipe';

document.addEventListener('DOMContentLoaded', function ()
{

    const quoteButton = document.querySelector('.header__btn-quote');

    if (!quoteButton) {
        return;
    }

    const contactSection = document.getElementById('contact');

    if (contactSection) {
        return;
    }

    quoteButton.removeAttribute('href');

    quoteButton.setAttribute(
        'data-modal-target',
        'modal-lets-us-converse'
    );

    quoteButton.setAttribute(
        'data-modal-toggle',
        'modal-lets-us-converse'
    );

    Fancybox.bind("[data-fancybox]", {
        Toolbar: {
            display: {
                left: ["infobar"],
                middle: [],
                right: ["close"],
            },
        },
    });

    initLocationMap();

    new AccordionSlider('#my-accordion', {
        addOns: [Autoplay, Breakpoints, TouchSwipe],
        width: '100%',
        height: 600,
        autoplay: true,
        responsive: true,
        responsiveMode: 'auto',
        panelDistance: 10,
        aspectRatio: 'auto',
        startPanel: 0,
        shadow: false,
        // touchSwipe: true,
        breakpoints: {
            1440: { visiblePanels: 4, height: 452},
            1280: { visiblePanels: 4, height: 452},
            1024: { visiblePanels: 4, height: 256},
            768: { visiblePanels: 4, height: 256},
            480: { visiblePanels: 4, height: 184, panelDistance: 5},
        },
    });

    const swiperAttributesEl = document.querySelector(".swiper-attributes");
    if (swiperAttributesEl) {
        const swiperAttributesTownhouse = new Swiper(swiperAttributesEl, {
            loop: true,
            modules: [Navigation],
            navigation: {
                nextEl: ".swiper-next-attributes",
                prevEl: ".swiper-prev-attributes",
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                }
            }
        });
    }

    document.querySelectorAll('.swiper-model-gallery').forEach((el) => {
        const id = el.dataset.galleryId;

        new Swiper(el, {
            loop: true,
            modules: [Navigation],
            navigation: {
                nextEl: `.swiper-next-gallery--${id}`,
                prevEl: `.swiper-prev-gallery--${id}`,
            },
            breakpoints: {
                320: {
                    slidesPerView: 2,
                    spaceBetween: 10
                },
                390: {
                    slidesPerView: 3,
                    spaceBetween: 10
                },
                768: {
                    slidesPerView: 4,
                    spaceBetween: 10
                },
            },
        });
    });

    const swiperModelsEl = document.querySelector(".swiper-models");
    if (swiperModelsEl) {
        const swiperModels = new Swiper(swiperModelsEl, {
            loop: false,
            modules: [Navigation],
            navigation: {
                nextEl: ".swiper-next-models",
                prevEl: ".swiper-prev-models",
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                }
            },
        });
    }

    new InitTabs({
        containerId: 'category-tabs',
        contentContainerSelector: '#category-tabs-content'
    });

    document.querySelectorAll('.list-options[id^="models-tabs-"]').forEach(container => {
        const categoriaSlug = container.id.replace('models-tabs-', '');
        new InitTabs({
            containerId: container.id,
            contentContainerSelector: `#models-tabs-content-${categoriaSlug}`
        });
    });

    const promo = document.querySelector('#promotion-quotes');

    if (promo) {
        const inner = promo.querySelector('.promotion');
        const btnClose = promo.querySelector('.btn-close');

        let cycleInterval;
        let hideTimeout;

        // Función para mostrar con fadeIn
        function fadeIn(element) {
            promo.style.display = 'block';
            // Pequeño delay para que la transición funcione
            setTimeout(() => {
                element.classList.remove('fade-out');
                element.classList.add('fade-in');
            }, 10);
        }

        function fadeOut(element) {
            element.classList.remove('fade-in');
            element.classList.add('fade-out');

            element.addEventListener('transitionend', function handler() {
                promo.style.display = 'none';
                element.removeEventListener('transitionend', handler);
            }, { once: true });
        }

        function startCycle() {
            fadeIn(inner);

            hideTimeout = setTimeout(() => {
                fadeOut(inner);
            }, 10000);
        }

        startCycle();

        // Repetir cada 30 segundos (10s visible + 20s oculto)
        cycleInterval = setInterval(startCycle, 30000);

        if (btnClose) {
            btnClose.addEventListener('click', () => {
                clearTimeout(hideTimeout);
                clearInterval(cycleInterval);
                fadeOut(inner);
            });
        }
    }

    const popupManager = new PopupManager();
    window.popupManager = popupManager;

});
